// extracted by mini-css-extract-plugin
export default {"switch":"EnterpriseAlertSwitch_switch__EJfoc","sliderTransparent":"EnterpriseAlertSwitch_sliderTransparent__6El6g","slider":"EnterpriseAlertSwitch_slider__R6jZN"};